export default __webpack_public_path__ + "3bb213a980343a380118ebe51e5db9f3.svg";